import React from "react";

const Marquee = ({ items, speed = 18, className = "" }) => {
  return (
    <div className={`overflow-hidden ${className}`}>
      <div
        className="flex whitespace-nowrap will-change-transform"
        style={{ animation: `marquee ${speed}s linear infinite` }}
      >
        {[...items, ...items].map((it, i) => (
          <div key={i} className="flex items-center gap-4 px-4">
            <span className="text-base md:text-lg font-bold uppercase tracking-wide text-white/90">
              {it}
            </span>
            <span className="text-orange-400 text-lg">~</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
